import type { OptionBase } from '~/components/molecule/Dropdown';

export type ActionType = 'delete' | 'activate' | 'deactivate';

export const actionOptions: Array<OptionBase & { payload: ActionType }> = [
  {
    label: 'Activeer geselecteerde flows',
    payload: 'activate',
    key: 'activate-selected-flows',
  },
  {
    label: 'Deactiveer geselecteerde flows',
    payload: 'deactivate',
    key: 'deactivate-selected-flows',
  },
  {
    label: 'Verwijder geselecteerde flows',
    payload: 'delete',
    key: 'delete-selected-flows',
  },
];
